var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85682 24.6416V29.57H6.16051C5.48004 29.57 4.92841 30.1216 4.92841 30.8021V52.98C4.92841 53.6604 5.48004 54.2121 6.16051 54.2121H38.1952C38.8757 54.2121 39.4273 53.6604 39.4273 52.98V44.3552H44.3557V54.2121C44.3557 56.934 42.1492 59.1405 39.4273 59.1405H14.7852L4.92841 68.9973V59.1405C2.20653 59.1405 0 56.934 0 54.2121V29.57C0 26.8481 2.20653 24.6416 4.92841 24.6416H9.85682Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0712 0C66.7931 0 68.9996 2.20652 68.9996 4.92841V34.4989C68.9996 37.2208 66.7931 39.4273 64.0712 39.4273V54.2125L49.286 39.4273H19.7155C16.9936 39.4273 14.7871 37.2208 14.7871 34.4989V4.92841C14.7871 2.20652 16.9936 0 19.7155 0H64.0712Z",
    fill: "#1B0076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0706 4.92871H19.7148V34.4992H51.3267L59.1421 42.3146V34.4992H64.0706V4.92871Z",
    fill: "#E1E6F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3553 19.7139V24.6423H24.6416V19.7139H44.3553Z",
    fill: "#E71E3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1405 9.85645V14.7849H24.6416V9.85645H59.1405Z",
    fill: "#E71E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2f002bb8.svg";
export { ForwardRef as ReactComponent };